import React from 'react';
import { IApplicationContext } from '../IApplicationContext';

export const ImageScannerApplicationContext = React.createContext<IApplicationContext>(undefined as any);
